// eslint-disable-next-line import/no-cycle
import emailPageConfig from '@/components/template-builder/config/templates/email/page-item-config';
// eslint-disable-next-line import/no-cycle
import emailColumnConfig from '@/components/template-builder/config/templates/email/column-item-config';
// eslint-disable-next-line import/no-cycle
import emailLineConfig from '@/components/template-builder/config/templates/email/line-item-config';
// eslint-disable-next-line import/no-cycle
import emailSectionConfig from '@/components/template-builder/config/templates/email/section-item-config';
// eslint-disable-next-line import/no-cycle
import emailCustomPageConfig from '@/components/template-builder/config/templates/email/custom-page-item-config';

// V4 Email configs
// eslint-disable-next-line import/no-cycle
import emailV4PageConfig from '@/components/template-builder/config/templates/email-v4/page-item-config';
// eslint-disable-next-line import/no-cycle
import emailV4ColumnConfig from '@/components/template-builder/config/templates/email-v4/column-item-config';
// eslint-disable-next-line import/no-cycle
import emailV4LineConfig from '@/components/template-builder/config/templates/email-v4/line-item-config';
// eslint-disable-next-line import/no-cycle
import emailV4SectionConfig from '@/components/template-builder/config/templates/email-v4/section-item-config';
// eslint-disable-next-line import/no-cycle
import emailV4CustomPageConfig from '@/components/template-builder/config/templates/email-v4/custom-page-item-config';

// eslint-disable-next-line import/no-cycle
import popupPageConfig from '@/components/template-builder/config/templates/popup/page-item-config';
// eslint-disable-next-line import/no-cycle
import popupColumnConfig from '@/components/template-builder/config/templates/popup/column-item-config';
// eslint-disable-next-line import/no-cycle
import popupLineConfig from '@/components/template-builder/config/templates/popup/line-item-config';
// eslint-disable-next-line import/no-cycle
import embedPageConfig from '@/components/template-builder/config/templates/embed/page-item-config';
// eslint-disable-next-line import/no-cycle
import embedColumnConfig from '@/components/template-builder/config/templates/embed/column-item-config';
// eslint-disable-next-line import/no-cycle
import embedLineConfig from '@/components/template-builder/config/templates/embed/line-item-config';

// V4 Popup configs
// eslint-disable-next-line import/no-cycle
import popupV4PageConfig from '@/components/template-builder/config/templates/popup-v4/page-item-config';
// eslint-disable-next-line import/no-cycle
import popupV4ColumnConfig from '@/components/template-builder/config/templates/popup-v4/column-item-config';
// eslint-disable-next-line import/no-cycle
import popupV4LineConfig from '@/components/template-builder/config/templates/popup-v4/line-item-config';

// V4 Embed configs
// eslint-disable-next-line import/no-cycle
import embedV4PageConfig from '@/components/template-builder/config/templates/embed-v4/page-item-config';
// eslint-disable-next-line import/no-cycle
import embedV4ColumnConfig from '@/components/template-builder/config/templates/embed-v4/column-item-config';
// eslint-disable-next-line import/no-cycle
import embedV4LineConfig from '@/components/template-builder/config/templates/embed-v4/line-item-config';

// eslint-disable-next-line import/no-cycle
import pushNotificationsPageConfig from '@/components/template-builder/config/templates/pushnotifications/page-item-config';

// eslint-disable-next-line import/no-cycle
import smsPageConfig from '@/components/template-builder/config/templates/sms/page-item-config';

// eslint-disable-next-line import/no-cycle
import richTextingPageConfig from '@/components/template-builder/config/templates/richtexting/page-item-config';

// eslint-disable-next-line import/no-cycle
import whatsappPageConfig from '@/components/template-builder/config/templates/whatsapp/page-item-config';

// Teaser configs
// eslint-disable-next-line import/no-cycle
import teaserPageConfig from '@/components/template-builder/config/templates/teaser/page-item-config';
// eslint-disable-next-line import/no-cycle
import teaserColumnConfig from '@/components/template-builder/config/templates/teaser/column-item-config';
// eslint-disable-next-line import/no-cycle
import teaserLineConfig from '@/components/template-builder/config/templates/teaser/line-item-config';

// eslint-disable-next-line import/no-cycle
import { ConfigurationPanelStructure, TemplateParentTypeEnum, WidgetTypeEnum } from '@/types';

// eslint-disable-next-line import/no-cycle
import getWidgetConfig, { getWidgetConfigV4 } from './widgets-config';

interface TemplateConfiguration {
  [key: string]: ConfigurationPanelStructure;
}

const getTemplateConfiguration = (templateType: TemplateParentTypeEnum, widgetType: WidgetTypeEnum|null, imported = false, isV4 = false): TemplateConfiguration => {
  let config: TemplateConfiguration;
  switch (templateType) {
    case TemplateParentTypeEnum.EMAIL:
      if (isV4) {
        config = {
          page: imported ? emailV4CustomPageConfig : emailV4PageConfig,
          section: emailV4SectionConfig,
          column: emailV4ColumnConfig,
          line: emailV4LineConfig,
        };
      } else {
        config = {
          page: imported ? emailCustomPageConfig : emailPageConfig,
          section: emailSectionConfig,
          column: emailColumnConfig,
          line: emailLineConfig,
        };
      }
      break;
    case TemplateParentTypeEnum.PUSHNOTIFICATIONS:
      config = {
        page: pushNotificationsPageConfig,
      };
      break;
    case TemplateParentTypeEnum.RICHTEXTING:
      config = {
        page: richTextingPageConfig,
      };
      break;
    case TemplateParentTypeEnum.WHATSAPP:
      config = {
        page: whatsappPageConfig,
      };
      break;
    case TemplateParentTypeEnum.SMS:
      config = {
        page: smsPageConfig,
      };
      break;
    case TemplateParentTypeEnum.FACEBOOKMESSENGER:
      config = {}; // No page configuration for Facebook Messenger
      break;
    case TemplateParentTypeEnum.POPUP:
      if (isV4) {
        config = {
          page: popupV4PageConfig,
          column: popupV4ColumnConfig,
          line: popupV4LineConfig,
        };
      } else {
        config = {
          page: popupPageConfig,
          column: popupColumnConfig,
          line: popupLineConfig,
        };
      }
      break;
    case TemplateParentTypeEnum.EMBED:
      if (isV4) {
        config = {
          page: embedV4PageConfig,
          column: embedV4ColumnConfig,
          line: embedV4LineConfig,
        };
      } else {
        config = {
          page: embedPageConfig,
          column: embedColumnConfig,
          line: embedLineConfig,
        };
      }
      break;
    case TemplateParentTypeEnum.TEASER:
      config = {
        page: teaserPageConfig,
        column: teaserColumnConfig,
        line: teaserLineConfig,
      };
      break;
    default:
      config = {
        page: popupPageConfig,
        column: popupColumnConfig,
      };
  }

  if (widgetType) {
    const widgetConfigGetter = isV4 ? getWidgetConfigV4 : getWidgetConfig;
    config.widget = widgetConfigGetter(templateType, widgetType, config.column?.items[0], config.section?.items[0], config.line?.items[0]);
  }

  return config;
};

export default getTemplateConfiguration;
